import { GsFormSchema } from 'libs/shared/src/components';
import { buttonSchemaFields } from '../components/basics/button-fields.schema';

/**
 * The schema for the global UI button settings form.
 * Defines all configurable button properties as a reusable building block.
 */
export const UI_BUTTON_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...buttonSchemaFields()
  ]
};
